import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const FEDEK = () => {
  const { t } = useTranslation();

  return (
    <PageTemplate title={t('fedek.title')}>
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-semibold text-hacettepe-blue mb-4">{t('fedek.what_is_fedek')}</h2>
        <p className="text-gray-700 leading-relaxed mb-6">
          {t('fedek.p1')}
        </p>
        <p className="text-gray-700 leading-relaxed mb-6">
          {t('fedek.p2')}
        </p>

        <h2 className="text-2xl font-semibold text-hacettepe-blue mb-4">{t('fedek.fedek_accreditation')}</h2>
        <p className="text-gray-700 leading-relaxed mb-6">
          {t('fedek.p3')}
        </p>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-6">
          <h2 className="text-2xl font-semibold text-hacettepe-blue mb-4">{t('fedek.accreditation_2021_2023')}</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            {t('fedek.p4')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="https://fs.hacettepe.edu.tr/fenyeni/dosyalar/fedek%20akreditasyon%202022.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-hacettepe-red hover:bg-hacettepe-red-dark transition-colors"
            >
              {t('fedek.view_certificates')}
            </a>
            <a
              href="https://fedek.hacettepe.edu.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-hacettepe-blue hover:bg-hacettepe-blue-dark transition-colors"
            >
              {t('fedek.fedek_website')}
            </a>
          </div>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
          <p className="text-gray-700 italic mb-0">
            {t('fedek.p5')}
          </p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default FEDEK; 